import Vue from 'vue';
import ProductsByPopularity from '@/plugins/graphql/queries/v2/inquiry/products-by-popularity.gql';
import { InquiryProductBasicModel } from '@/helpers/entities/models/InquiryProductBasicModel';
export default Vue.extend({
    apollo: {
        popularProducts: {
            query: ProductsByPopularity,
            variables() {
                return {
                    appUuid: this.appUuid,
                    first: this.limit,
                };
            },
            update(data) {
                const nodes = data.inquiryProductsByMiniAppViews.edges;
                return nodes.map((productNode) => {
                    return new InquiryProductBasicModel(productNode.node);
                });
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        limit: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            popularProducts: null,
        };
    },
    computed: {
        showLinkButton() {
            const products = this.popularProducts;
            const fiveRecords = 5;
            return !!products && products.length >= fiveRecords;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                popularProducts: this.popularProducts,
                showLinkButton: this.showLinkButton,
            });
        }
    },
});
